import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import React, { useEffect, useState } from 'react';
import classes from './Countdown.module.scss';
dayjs.extend(duration);
const Countdown = ({ targetDate, small }) => {
    const [timeLeft, setTimeLeft] = useState(dayjs.duration(0));
    useEffect(() => {
        let interval;
        if (targetDate) {
            const computeRemaining = () => {
                const now = dayjs();
                const end = dayjs(targetDate);
                const diff = end.diff(now);
                if (diff <= 0) {
                    setTimeLeft(dayjs.duration(0));
                    return false;
                }
                else {
                    setTimeLeft(dayjs.duration(diff));
                    return true;
                }
            };
            let stillCounting = computeRemaining();
            interval = setInterval(() => {
                stillCounting = computeRemaining();
                if (!stillCounting) {
                    clearInterval(interval);
                }
            }, 1000);
        }
        else {
            interval = setInterval(() => {
                setTimeLeft((prev) => prev.add(1, 'second'));
            }, 1000);
        }
        return () => {
            clearInterval(interval);
        };
    }, [targetDate]);
    const formatTime = () => {
        const hours = Math.floor(timeLeft.asHours()).toString().padStart(2, '0');
        const minutes = timeLeft.minutes().toString().padStart(2, '0');
        const seconds = timeLeft.seconds().toString().padStart(2, '0');
        return [hours, minutes, seconds];
    };
    const [hours, minutes, seconds] = formatTime();
    return (React.createElement("div", { className: `${classes.countdown} ${small ? classes.countdownSmall : ''}` },
        React.createElement("div", { className: classes.countdownItem }, hours),
        React.createElement("div", { className: classes.countdownItem }, minutes),
        React.createElement("div", { className: classes.countdownItem }, seconds)));
};
export default Countdown;
